export default __webpack_public_path__ + "static/media/artorias--side.be710d80.jpg";